export default [
  {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '/',
    component: () => import('@/layouts/main/Main.vue'),
    redirect: '/home',
    meta:{
      authPosition: 2,
      authRequired: true,
      deviceRequired: false
    },
    children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: {
          deviceRequired: true,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'breadcrumb.home.dashboard',
              active: true
            }
          ],
          pageTitle: 'breadcrumb.home.dashboard'
        }
      },
      // =============================================================================
      // Theme Routes
      // =============================================================================
      {
        path: '/graph/:boardId',
        name: 'graph',
        component: () => import('@/views/graph/Index'),
        meta: {
          deviceRequired: true,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'breadcrumb.home.dashboard',
              active: true
            }
          ],
          pageTitle: 'breadcrumb.home.dashboard'
        }
      },

      // content
      {
        path: '/notice',
        name: 'page-notice',
        component: () => import('@/views/content/notice/Noticeboard.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '게시판관리'},
            {
              title: 'nav.main.공지사항',
              url: {name: 'page-notice'},
              active: true
            }
          ],
          pageTitle: 'nav.main.공지사항'
        }
      },
      {
        path: '/notice-read',
        name: 'page-notice-read',
        component: () => import('@/views/content/notice/Noticeread.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '게시판관리'},
            {
              title: 'nav.main.공지사항',
              url: {name: 'page-notice'}
            },
            {
              title: 'nav.main.공지사항상세보기',
              url: {name: 'page-notice-read'},
              active: true
            }
          ],
          pageTitle: 'nav.main.공지사항',
          parent: 'page-notice'
        }
      },
      {
        path: '/notice-write',
        name: 'page-notice-write',
        component: () => import('@/views/content/notice/Noticewrite.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.게시판관리'},
            {
              title: 'nav.main.공지사항',
              url: {name: 'page-notice'}
            },
            {
              title: 'nav.main.공지사항작성하기',
              url: {name: 'page-notice-write'},
              active: true
            }
          ],
          pageTitle: 'nav.main.공지사항',
          parent: 'page-notice'
        }
      },

      // 결재
      {
        path: '/approval-write',
        name: 'page-approval-write',
        component: () => import('@/views/content/approval/ApprovalWrite.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.결재문서 작성',
              url: {name: 'page-approval-write'},
              active: true
            }
          ],
          pageTitle: 'nav.main.결재문서 작성'
        }
      },

      {
        path: '/approval-request',
        name: 'page-approval-request',
        component: () => import('@/views/content/approval/ApprovalRequest.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.결재요청함',
              url: {name: 'page-approval-request'},
              active: true
            }
          ],
          pageTitle: 'nav.main.결재요청함'
        }
      },
      {
        path: '/approval-await',
        name: 'page-approval-await',
        component: () => import('@/views/content/approval/ApprovalAwait.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.결재대기함',
              url: {name: 'page-approval-await'},
              active: true
            }
          ],
          pageTitle: 'nav.main.결재대기함'
        }
      },

      {
        path: '/approval-process',
        name: 'page-approval-process',
        component: () => import('@/views/content/approval/ApprovalProcess.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.결재진행함',
              url: {name: 'page-approval-process'},
              active: true
            }
          ],
          pageTitle: 'nav.main.결재진행함'
        }
      },

      {
        path: '/approval-complete',
        name: 'page-approval-complete',
        component: () => import('@/views/content/approval/ApprovalComplete.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.완료문서함',
              url: {name: 'page-approval-complete'},
              active: true
            }
          ],
          pageTitle: 'nav.main.완료문서함'
        }
      },

      {
        path: '/approval-reject',
        name: 'page-approval-reject',
        component: () => import('@/views/content/approval/ApprovalReject.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.반려문서함',
              url: {name: 'page-approval-reject'},
              active: true
            }
          ],
          pageTitle: 'nav.main.반려문서함'
        }
      },

      {
        path: '/approval-reference',
        name: 'page-approval-reference',
        component: () => import('@/views/content/approval/ApprovalReference.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.참조/회람문서함',
              url: {name: 'page-approval-reference'},
              active: true
            }
          ],
          pageTitle: 'nav.main.참조/회람문서함'
        }
      },

      // read - sub router
      {
        path: '/approval-await-read',
        name: 'page-approval-await-read',
        component: () => import('@/views/content/approval/ApprovalRead.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.결재대기함',
              url: {name: 'page-approval-await'},
              active: true
            }
          ],
          pageTitle: 'nav.main.결재대기함',
          parent: 'page-approval-await'
        }
      },
      {
        path: '/approval-process-read',
        name: 'page-approval-process-read',
        component: () => import('@/views/content/approval/ApprovalRead.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.결재진행함',
              url: {name: 'page-approval-process'},
              active: true
            }
          ],
          pageTitle: 'nav.main.결재진행함',
          parent: 'page-approval-process'
        }
      },
      {
        path: '/approval-complete-read',
        name: 'page-approval-complete-read',
        component: () => import('@/views/content/approval/ApprovalRead.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.완료문서함',
              url: {name: 'page-approval-complete'},
              active: true
            }
          ],
          pageTitle: 'nav.main.완료문서함',
          parent: 'page-approval-complete'
        }
      },
      {
        path: '/approval-reject-read',
        name: 'page-approval-reject-read',
        component: () => import('@/views/content/approval/ApprovalRead.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: 'nav.main.결재관리'},
            {
              title: 'nav.main.반려문서함',
              url: {name: 'page-approval-reject'},
              active: true
            }
          ],
          pageTitle: 'nav.main.반려문서함',
          parent: 'page-approval-reject'
        }
      },


      // FAQ
      {
        path: '/faq',
        name: 'page-faq',
        component: () => import('@/views/content/faq/FAQBoard.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.게시판관리'},
            {
              title: 'nav.main.FAQ',
              url: {name: 'page-faq'},
              active: true
            }
          ],
          pageTitle: 'nav.main.FAQ'
        }
      },


      // 프로젝트
      {
        path: '/content/project',
        name: 'content-project',
        component: () => import('@/views/content/project/ProjectList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'nav.main.사무소 바로가기',
              active: true
            }
          ],
          pageTitle: 'nav.main.사무소 바로가기'
        }
      },
      {
        path: '/content/project/create',
        name: 'content-project-create',
        component: () => import('@/views/content/project/ProjectWrite.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'nav.main.프로젝트',
              active: true
            }
          ],
          pageTitle: 'breadcrumb.content.project.create.title'
        }
      },

      // 안전·보건 예산
      {
        path: '/content/business-status/report',
        name: 'content-business-status-report',
        component: () => import('@/views/content/business-status/BusinessStatusReport.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'nav.main.안전·보건 예산',
              active: true
            },
            {
              title: 'nav.main.안전·보건예산 현황',
              url: {name: 'content-business-status-monitoring'},
              active: true
            }
          ],
          pageTitle: 'nav.main.안전·보건예산 현황'
        }
      },
      {
        path: '/content/business-status/monitoring',
        name: 'content-business-status-monitoring',
        component: () => import('@/views/content/business-status/BusinessStatusMonitoring.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'nav.main.안전·보건 예산',
              active: true
            },
            {
              title: 'nav.main.현장모니터링',
              url: {name: 'content-business-status-monitoring'},
              active: true
            }
          ],
          pageTitle: 'nav.main.현장모니터링'
        }
      },

      // 사무소 개요 - 프로잭트 개요
      {
        path: '/content/plan/project/info',
        name: 'content-plan-project-info',
        component: () => import('@/views/content/plan/PlanProjectInfo.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'nav.main.사무소 개요',
              active: true
            },
            {
              title: 'nav.main.사무소 상세',
              active: true
            },
            {
              title: 'nav.main.사무소 정보',
              active: true
            }
          ],
          pageTitle: 'nav.main.사무소 정보',
          parent: 'content-plan-project'
        }
      },
      {
        path: '/content/plan/project/origin-chart',
        name: 'content-plan-project-origin-chart',
        component: () => import('@/views/content/plan/PlanProjectOriginChart.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'nav.main.사무소 개요',
              active: true
            },
            {
              title: 'nav.main.사무소 상세',
              active: true
            },
            {
              title: 'nav.main.조직도',
              active: true
            }
          ],
          pageTitle: 'nav.main.조직도',
          parent: 'content-plan-project'
        }
      },

      // 사무소 개요 - 파트너사 개요
      { // 계약 현황
        path: '/content/plan/partner/list',
        name: 'content-plan-partner-list',
        component: () => import('@/views/content/plan/PlanPartnerList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'nav.main.사무소 개요',
              active: true
            },
            {
              title: 'nav.main.파트너사 계약 현황',
              active: true
            },
            {
              title: 'nav.main.계약 현황',
              active: true
            }
          ],
          pageTitle: 'nav.main.계약 현황',
          parent: 'content-plan-project'
        }
      },

      { // 파트너사 등록 요청
        path: '/content/plan/partner/join-request',
        name: 'content-plan-partner-join-request',
        component: () => import('@/views/content/plan/PlanPartnerJoinRequest.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'nav.main.사무소 개요',
              active: true
            },
            {
              title: '파트너사 등록 요청',
              active: true
            }
          ],
          pageTitle: '파트너사 등록 요청',
          parent: 'content-plan-partner-join-request'
        }
      },

      { // 안전보건부서장(현장대리인) 지정
        path: '/content/plan/partner/agent',
        name: 'content-plan-partner-agent',
        component: () => import('@/views/content/plan/PlanPartnerAgent.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {
              title: 'nav.main.사무소 개요',
              active: true
            },
            {
              title: 'nav.main.파트너사 개요',
              active: true
            },
            {
              title: 'nav.main.안전보건부서장(현장대리인) 지정',
              active: true
            }
          ],
          pageTitle: 'nav.main.안전보건부서장(현장대리인) 지정',
          parent: 'content-plan-project'
        }
      },

      // 위험성평가
      { // 위험성평가 / 위험성평가 / 최초 위험성평가
        path: '/content/risk/assessment/first',
        name: 'content-risk-assessment-first',
        component: () => import('@/views/content/risk/RiskAssessmentFirst.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.최초 위험성평가', active: true}
          ],
          pageTitle: 'nav.main.최초 위험성평가',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 위험성평가 / 정기위험성평가
        path: '/content/risk/assessment/regular',
        name: 'content-risk-assessment-regular',
        component: () => import('@/views/content/risk/RiskAssessmentRegular.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.정기 위험성평가', active: true}
          ],
          pageTitle: 'nav.main.정기 위험성평가',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 위험성평가 / 위험성평가기초자료
        path: '/content/risk/assessment/stddoc',
        name: 'content-risk-assessment-stddoc',
        component: () => import('@/views/content/risk/RiskAssessmentStddoc.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.위험성평가기초자료', active: true}
          ],
          pageTitle: 'nav.main.위험성평가기초자료',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 위험성평가 / 수시위험성평가
        path: '/content/risk/assessment/always',
        name: 'content-risk-assessment-always',
        component: () => import('@/views/content/risk/RiskAssessmentAlways.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.수시 위험성평가', active: true}
          ],
          pageTitle: 'nav.main.수시 위험성평가',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 협의체회의 / 위험성평가협의회
        path: '/content/risk/conference/warning',
        name: 'content-risk-conference-warning',
        component: () => import('@/views/content/risk/RiskConferenceWarning.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.협의체회의'},
            {title: 'nav.main.정기 위험성평가협의회', active: true}
          ],
          pageTitle: 'nav.main.정기 위험성평가협의회',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 협의체회의 / 위험성평가협의회
        path: '/content/risk/conference/warning_always',
        name: 'content-risk-conference-warning-always',
        component: () => import('@/views/content/risk/RiskConferenceWarningAlways.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.협의체회의'},
            {title: 'nav.main.수시 위험성평가협의회', active: true}
          ],
          pageTitle: 'nav.main.수시 위험성평가협의회',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 협의체회의 / 산업안전보건위원회
        path: '/content/risk/conference/safety',
        name: 'content-risk-conference-safety',
        component: () => import('@/views/content/risk/RiskConferenceSafety.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.협의체회의'},
            {title: 'nav.main.산업안전보건위원회', active: true}
          ],
          pageTitle: 'nav.main.산업안전보건위원회',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 작업허가서 / 작업허가서
        path: '/content/risk/permit/work',
        name: 'content-risk-permit-work',
        component: () => import('@/views/content/risk/RiskPermitWork.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.작업허가서'},
            {title: 'nav.main.작업허가서(내부용)', active: true}
          ],
          pageTitle: 'nav.main.작업허가서(내부용)',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 작업허가서 / 작업허가서(외부용)
        path: '/content/risk/permit/work_export',
        name: 'content-risk-permit-work-export',
        component: () => import('@/views/content/risk/RiskPermitSpecial.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.작업허가서'},
            {title: 'nav.main.작업허가서(외부용)', active: true}
          ],
          pageTitle: 'nav.main.작업허가서(외부용)',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 안전점검 및 개선 / 일일안전점검표
        path: '/content/risk/check/checklist',
        name: 'content-risk-check-checklist',
        component: () => import('@/views/content/risk/RiskCheckCheckList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.위험성평가'},
            {title: 'nav.main.안전점검 및 개선'},
            {title: 'nav.main.일일안전점검표', active: true}
          ],
          pageTitle: 'nav.main.일일안전점검표',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 안전점검 및 개선 / 안전점검일지
        path: '/content/risk/check/checklog',
        name: 'content-risk-check-checklog',
        component: () => import('@/views/content/risk/RiskCheckCheckLog.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.안전점검'},
            {title: 'nav.main.안전점검'},
            {title: 'nav.main.4_4_4 점검', active: true}
          ],
          pageTitle: 'nav.main.4_4_4 점검',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 안전점검 및 개선 / 합동점검일지
        path: '/content/risk/check/checklogall',
        name: 'content-risk-check-checklistall',
        component: () => import('@/views/content/risk/RiskCheckCheckLogAll.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.안전점검 및 개선'},
            {title: 'nav.main.합동점검일지', active: true}
          ],
          pageTitle: 'nav.main.합동점검일지',
          parent: 'content-plan-project'
        }
      },
      { // 위험성평가 / 안전점검
        path: '/content/risk/check/:boardSlug',
        name: 'content-risk-check-list',
        component: () => import('@/views/content/risk/RiskCheckList.vue'),
        meta: {
          parent: 'content-plan-project'
        }
      },

      // 안전실적
      { // 안전실적 / 안전보건책임자선임
        path: '/content/safety/director',
        name: 'content-safety-director',
        component: () => import('@/views/content/safety/SafetyDirector.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.안전보건책임자선임'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.안전보건책임자선임',
          parent: 'content-plan-project'
        }
      },
      { //
        path: '/content/safety/equipment/plan',
        name: 'content-safety-equipment-plan',
        component: () => import('@/views/content/safety/SafetyEquipment.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.장비점검 현황'},
            {title: 'nav.main.장비점검 계획', active: true}
          ],
          pageTitle: 'nav.main.장비점검 계획',
          parent: 'content-plan-project'
        }
      },
      { //
        path: '/content/safety/equipment/result',
        name: 'content-safety-equipment-result',
        component: () => import('@/views/content/safety/SafetyEquipment2.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.장비점검 현황'},
            {title: 'nav.main.장비점검 결과', active: true}
          ],
          pageTitle: 'nav.main.장비점검 결과',
          parent: 'content-plan-project'
        }
      },

      { // 파트너 444
        path: '/content/risk/check/checklog-partner',
        name: 'content-risk-check-checklog-partner',
        component: () => import('@/views/content/risk/RiskCheckCheckLogPartner.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.일일안전점검일지'},
            {title: 'nav.main.일일안전점검일지', active: true}
          ],
          pageTitle: 'nav.main.일일안전점검일지',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 인원투입 현황 / 인원투입 입력
        path: '/content/safety/staff/create',
        name: 'content-safety-staff-create',
        component: () => import('@/views/content/safety/SafetyStaffCreate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.인원투입 현황'},
            {title: 'nav.main.인원투입 입력'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.인원투입 입력',
          parent: 'safety-staff'
        }
      },
      { // 안전실적 / 인원투입 현황 / 인원투입 현황
        path: '/content/safety/staff/managerment',
        name: 'content-safety-staff-managerment',
        component: () => import('@/views/content/safety/SafetyStaffManagerment.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.인원투입 현황'},
            {title: 'nav.main.인원투입 관리', active: true}
          ],
          pageTitle: 'nav.main.인원투입 관리',
          parent: 'safety-staff'
        }
      },
      { // 안전실적 / 인원투입 현황 / 출역인원조회
        path: '/content/safety/staff/list',
        name: 'content-safety-staff-list',
        component: () => import('@/views/content/safety/SafetyStaffList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.인원투입 현황'},
            {title: 'nav.main.인원투입 조회', active: true}
          ],
          pageTitle: 'nav.main.인원투입 조회',
          parent: 'safety-staff'
        }
      },
      { // 안전실적 / 인원투입 현황 / 인원투입 입력
        path: '/content/safety/equipment/create',
        name: 'content-safety-equipment-create',
        component: () => import('@/views/content/safety/SafetyEquipmentCreate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.장비투입 현황'},
            {title: 'nav.main.장비투입 입력'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.장비투입 입력',
          parent: 'safety-staff'
        }
      },
      { // 안전실적 / 인원투입 현황 / 인원투입 현황
        path: '/content/safety/equipment/managerment',
        name: 'content-safety-equipment-managerment',
        component: () => import('@/views/content/safety/SafetyEquipmentManagerment.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.장비투입 현황'},
            {title: 'nav.main.장비투입 현황', active: true}
          ],
          pageTitle: 'nav.main.장비투입 현황',
          parent: 'safety-staff'
        }
      },
      { // 안전실적 / 인원투입 현황 / 출역인원조회
        path: '/content/safety/equipment/list',
        name: 'content-safety-equipment-list',
        component: () => import('@/views/content/safety/SafetyEquipmentList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.장비투입 현황'},
            {title: 'nav.main.장비투입 조회', active: true}
          ],
          pageTitle: 'nav.main.장비투입 조회',
          parent: 'safety-staff'
        }
      },
      { // 안전실적 / 산업재해무재해 / 사고보고
        path: '/content/safety/accident/report',
        name: 'content-safety-accident-report',
        component: () => import('@/views/content/safety/SafetyAccidentReport.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.산업재해발생'},
            {title: 'nav.main.안전사고'},
            {title: 'nav.main.사고보고', active: true}
          ],
          pageTitle: 'nav.main.사고보고',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 산업재해무재해 / 산재검토
        path: '/content/safety/accident/review',
        name: 'content-safety-accident-review',
        component: () => import('@/views/content/safety/SafetyAccidentReview.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.산업재해발생'},
            {title: 'nav.main.안전사고'},
            {title: 'nav.main.산업재해검토', active: true}
          ],
          pageTitle: 'nav.main.산업재해검토',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 산업재해무재해 / 산재발생현황
        path: '/content/safety/accident/list',
        name: 'content-safety-accident-list',
        component: () => import('@/views/content/safety/SafetyAccidentList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.산업재해발생'},
            {title: 'nav.main.안전사고'},
            {title: 'nav.main.산업재해발생 현황', active: true}
          ],
          pageTitle: 'nav.main.산업재해발생 현황',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 산업재해무재해 / 사고분석
        path: '/content/safety/accident/analysis',
        name: 'content-safety-accident-analysis',
        component: () => import('@/views/content/safety/SafetyAccidentAnalysis.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.안전실적'},
            {title: 'nav.main.산업재해무재해'},
            {title: 'nav.main.사고분석', active: true}
          ],
          pageTitle: 'nav.main.사고분석',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 산업재해무재해 / 인원투입 현황
        path: '/content/safety/accident/numberofstaff',
        name: 'content-safety-accident-numberofstaff',
        component: () => import('@/views/content/safety/SafetyAccidentNumberOfStaff.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.안전실적'},
            {title: 'nav.main.인원투입 현황'},
            {title: '일별', active: true}
          ],
          pageTitle: 'nav.main.인원투입 현황',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 산업재해무재해 / 안전전관리율 기초자료
        path: '/content/safety/accident/basicdata',
        name: 'content-safety-accident-basicdata',
        component: () => import('@/views/content/safety/SafetyAccidentBasicData.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.산업재해무재해'},
            {title: 'nav.main.안전관리율 기초자료', active: true}
          ],
          pageTitle: 'nav.main.안전관리율 기초자료',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 안전용품 / 안전용품 구매신청
        path: '/content/safety/supplies/apply',
        name: 'content-safety-supplies-apply',
        component: () => import('@/views/content/safety/SafetySuppliesApply.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.안전용품 현황'},
            {title: 'nav.main.안전용품 구매신청'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.안전용품 구매신청',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 건설장비관리 / 장비점검 계획
        path: '/content/safety/equipment/monthly',
        name: 'content-safety-equipment-monthly',
        component: () => import('@/views/content/safety/SafetyEquipmentMonthly.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.건설장비관리'},
            {title: 'nav.main.장비점검 계획', active: true}
          ],
          pageTitle: 'nav.main.장비점검 계획',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 건설장비관리 / 장비점검 결과
        path: '/content/safety/equipment/check',
        name: 'content-safety-equipment-check',
        component: () => import('@/views/content/safety/SafetyEquipmentCheck.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.파트너사 일일보고'},
            {title: 'nav.main.건설장비관리'},
            {title: 'nav.main.장비점검 결과'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.장비점검 결과',
          parent: 'content-plan-project'
        }
      },


      { // 안전실적 / 시정 및 예방요청 / 시정 및 예방요청
        path: '/content/safety/prevention/request',
        name: 'content-safety-prevention-request',
        component: () => import('@/views/content/safety/SafetyPreventionRequest.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.시정 및 예방요청'},
            {title: '시정 및 예방조치'},
            {title: 'nav.main.안전', active: true}
          ],
          pageTitle: 'nav.main.안전',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 시정 및 예방요청 / 요청서 집계
        path: '/content/safety/prevention/total',
        name: 'content-safety-prevention-total',
        component: () => import('@/views/content/safety/SafetyPreventionTotal.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: '시정 및 예방요청'},
            {title: 'nav.main.시정 및 예방조치'},
            {title: 'nav.main.형태별 분류', active: true}
          ],
          pageTitle: 'nav.main.형태별 분류',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 안전교육 / 교육 현황
        path: '/content/safety/hse/list',
        name: 'content-safety-hse-list',
        component: () => import('@/views/content/safety/SafetyHseList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.안전교육'},
            {title: 'nav.main.교육 현황', active: true}
          ],
          pageTitle: 'nav.main.교육 현황',
          parent: 'content-plan-project'
        }
      },
      { // 안전실적 / 안전교육 / 교육 모니터링
        path: '/content/safety/hse/monitoring',
        name: 'content-safety-hse-monitoring',
        component: () => import('@/views/content/safety/SafetyHseMonitoring.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.안전교육'},
            {title: 'nav.main.교육 모니터링', active: true}
          ],
          pageTitle: 'nav.main.교육 모니터링',
          parent: 'content-plan-project'
        }
      },


      // 환경실적
      { // 환경실적 / 환경책임자선임 / 환경책임자선임
        path: '/content/state/director/list',
        name: 'content-state-director-list',
        component: () => import('@/views/content/state/StateDirectorList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경책임자선임'},
            {title: 'nav.main.환경책임자선임', active: true}
          ],
          pageTitle: 'nav.main.환경책임자선임',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 대관업무 / 대관인허가체크
        path: '/content/state/government/check',
        name: 'content-state-government-check',
        component: () => import('@/views/content/state/StateGovernmentCheck.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.대관업무'},
            {title: 'nav.main.대관인허가체크', active: true}
          ],
          pageTitle: 'nav.main.대관인허가체크',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 대관업무 / 대관인허가신고
        path: '/content/state/government/declar',
        name: 'content-state-government-declar',
        component: () => import('@/views/content/state/StateGovernmentDeclar.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.대관업무'},
            {title: 'nav.main.대관인허가신고', active: true}
          ],
          pageTitle: 'nav.main.대관인허가신고',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 대관업무 / 대관인허가모니터링
        path: '/content/state/government/monitoring',
        name: 'content-state-government-monitoring',
        component: () => import('@/views/content/state/StateGovernmentMonitoring.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.대관업무'},
            {title: 'nav.main.대관인허가모니터링', active: true}
          ],
          pageTitle: 'nav.main.대관인허가모니터링',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 환경교육 / 환경교육
        path: '/content/state/hse/list',
        name: 'content-state-hse-list',
        component: () => import('@/views/content/state/StateHSEList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경교육'},
            {title: 'nav.main.환경교육', active: true}
          ],
          pageTitle: 'nav.main.환경교육',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 환경교육 / 환경교육 모니터링
        path: '/content/state/hse/monitoring',
        name: 'content-state-hse-monitoring',
        component: () => import('@/views/content/state/StateHSEMonitoring.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경교육'},
            {title: 'nav.main.교육 모니터링', active: true}
          ],
          pageTitle: 'nav.main.교육 모니터링',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 환경점검 / 일일점검
        path: '/content/state/check/daily',
        name: 'content-state-check-daily',
        component: () => import('@/views/content/state/StateCheckDaily.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경점검'},
            {title: 'nav.main.일일점검', active: true}
          ],
          pageTitle: 'nav.main.일일점검',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 환경점검 / 월간점검
        path: '/content/state/check/monthly',
        name: 'content-state-check-monthly',
        component: () => import('@/views/content/state/StateCheckMonthly.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경점검'},
            {title: 'nav.main.월간점검', active: true}
          ],
          pageTitle: 'nav.main.월간점검',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 환경점검 / 환경점검모니터링
        path: '/content/state/check/monitoring',
        name: 'content-state-check-monitoring',
        component: () => import('@/views/content/state/StateCheckMonitoring.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경점검'},
            {title: 'nav.main.환경점검모니터링', active: true}
          ],
          pageTitle: 'nav.main.환경점검모니터링',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 환경지원 / 환경지원보고
        path: '/content/state/support/report',
        name: 'content-state-support-report',
        component: () => import('@/views/content/state/StateSupportReport.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경지원'},
            {title: 'nav.main.환경지원보고', active: true}
          ],
          pageTitle: 'nav.main.환경지원보고',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 환경평가 / 환경영향평가
        path: '/content/state/evaluation/list',
        name: 'content-state-evaluation-list',
        component: () => import('@/views/content/state/StateEvaluationList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경평가'},
            {title: 'nav.main.환경영향평가', active: true}
          ],
          pageTitle: 'nav.main.환경영향평가',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 시정 및 예방요청 / 시정 및 예방요청서
        path: '/content/state/prevention/request',
        name: 'content-state-prevention-request',
        component: () => import('@/views/content/state/StatePreventionRequest.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.시정 및 예방요청서'},
            {title: 'nav.main.시정 및 예방요청서', active: true}
          ],
          pageTitle: 'nav.main.시정 및 예방요청서',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 시정 및 예방요청 / 형태별 분류
        path: '/content/state/prevention/total',
        name: 'content-state-prevention-total',
        component: () => import('@/views/content/state/StatePreventionTotal.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.시정 및 예방요청서'},
            {title: 'nav.main.요청서 집계', active: true}
          ],
          pageTitle: 'nav.main.요청서 집계',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 환경사고 및 이슈 / 환경사고보고
        path: '/content/state/report/problem',
        name: 'content-state-report-problem',
        component: () => import('@/views/content/state/StateReportProblem.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경사고/이슈보고'},
            {title: 'nav.main.환경사고보고', active: true}
          ],
          pageTitle: 'nav.main.환경사고보고',
          parent: 'content-plan-project'
        }
      },
      { // 환경실적 / 환경사고 및 이슈 / 환경이슈보고
        path: '/content/state/report/issue',
        name: 'content-state-report-issue',
        component: () => import('@/views/content/state/StateReportIssue.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.환경실적'},
            {title: 'nav.main.환경사고/이슈보고'},
            {title: 'nav.main.환경이슈보고', active: true}
          ],
          pageTitle: 'nav.main.환경이슈보고',
          parent: 'content-plan-project'
        }
      },
      { // 보건실적 / 시정 및 예방요청
        path: '/content/health/request',
        name: 'content-health-request',
        component: () => import('@/views/content/health/HealthRequest.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.시정 및 예방요청'},
            {title: '시정 및 예방조치'},
            {title: 'nav.main.보건', active: true}
          ],
          pageTitle: 'nav.main.보건',
          parent: 'content-plan-project'
        }
      },
      { // 보건실적 / 보건교육 / 교육 현황
        path: '/content/health/education/list',
        name: 'content-health-education-list',
        component: () => import('@/views/content/health/HealthEducationList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.보건교육'},
            {title: 'nav.main.교육 현황', active: true}
          ],
          pageTitle: 'nav.main.교육 현황',
          parent: 'content-plan-project'
        }
      },
      { // 보건실적 / 보건교육 / 교육 모니터링
        path: '/content/health/education/monitoring',
        name: 'content-health-education-monitoring',
        component: () => import('@/views/content/health/HealthEducationMonitoring.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.보건교육'},
            {title: 'nav.main.교육 모니터링', active: true}
          ],
          pageTitle: 'nav.main.교육 모니터링',
          parent: 'content-plan-project'
        }
      },

      //커뮤니티
      { // 커뮤니티 / CEO 메세지
        path: '/content/community/businessnews',
        name: 'content-community-businessnews',
        component: () => import('@/views/content/community/CommunityBusinessnews.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / CEO 메세지
        path: '/content/community/businessnews/create',
        name: 'content-community-businessnews-create',
        component: () => import('@/views/content/community/CommunityBusinessnewsCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / CEO 메세지
        path: '/content/community/businessnews/:postId',
        name: 'content-community-businessnews-detail',
        component: () => import('@/views/content/community/CommunityBusinessnewsDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / CEO 메세지
        path: '/content/community/businessnews/:postId/update',
        name: 'content-community-businessnews-update',
        component: () => import('@/views/content/community/CommunityBusinessnewsUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / CEO 메세지
        path: '/content/community/businessnews/:postId/reply',
        name: 'content-community-businessnews-reply',
        component: () => import('@/views/content/community/CommunityBusinessnewsReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/content/community/qna',
        name: 'content-community-qna',
        component: () => import('@/views/content/community/CommunityQna.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.Q&A'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/content/community/qna/create',
        name: 'content-community-qna-create',
        component: () => import('@/views/content/community/CommunityQnaCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.Q&A'},
            {title: '작성', active: true}
          ],
          pageTitle: 'nav.main.Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/content/community/qna/:postId',
        name: 'content-community-qna-detail',
        component: () => import('@/views/content/community/CommunityQnaDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.Q&A'},
            {title: '상세', active: true}
          ],
          pageTitle: 'nav.main.Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/content/community/qna/:postId/update',
        name: 'content-community-qna-update',
        component: () => import('@/views/content/community/CommunityQnaUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.Q&A'},
            {title: '수정', active: true}
          ],
          pageTitle: 'nav.main.Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/content/community/qna/:postId/reply',
        name: 'content-community-qna-reply',
        component: () => import('@/views/content/community/CommunityQnaReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.Q&A'},
            {title: '답변', active: true}
          ],
          pageTitle: 'nav.main.Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: '/content/community/healthinfo',
        name: 'content-community-healthinfo',
        component: () => import('@/views/content/community/CommunityHealthInfo.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: '/content/community/healthinfo/create',
        name: 'content-community-healthinfo-create',
        component: () => import('@/views/content/community/CommunityHealthInfoCreate.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: '/content/community/healthinfo/:postId',
        name: 'content-community-healthinfo-detail',
        component: () => import('@/views/content/community/CommunityHealthInfoDetail.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: '/content/community/healthinfo/:postId/update',
        name: 'content-community-healthinfo-update',
        component: () => import('@/views/content/community/CommunityHealthInfoUpdate.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: '/content/community/healthinfo/:postId/reply',
        name: 'content-community-healthinfo-reply',
        component: () => import('@/views/content/community/CommunityHealthInfoReply.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/content/community/unitbusinessnews',
        name: 'content-community-unitbusinessnews',
        component: () => import('@/views/content/community/CommunityUnitBusinessNews.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/content/community/unitbusinessnews/create',
        name: 'content-community-unitbusinessnews-create',
        component: () => import('@/views/content/community/CommunityUnitBusinessNewsCreate.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/content/community/unitbusinessnews/:postId',
        name: 'content-community-unitbusinessnews-detail',
        component: () => import('@/views/content/community/CommunityUnitBusinessNewsDetail.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/content/community/unitbusinessnews/:postId/update',
        name: 'content-community-unitbusinessnews-update',
        component: () => import('@/views/content/community/CommunityUnitBusinessNewsUpdate.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/content/community/unitbusinessnews/:postId/reply',
        name: 'content-community-unitbusinessnews-reply',
        component: () => import('@/views/content/community/CommunityUnitBusinessNewsReply.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.커뮤니티'},
            {title: 'nav.main.구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: 'nav.main.안전보건 주요일정',
          parent: 'content_community_unitbusinessnews'
        }
      },

      // 마이페이지
      { // 마이페이지 / 업무현황
        path: '/content/mypage/workstatus',
        name: 'content-mypage-workstatus',
        component: () => import('@/views/content/mypage/MyPageWorkStatus.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.마이페이지'},
            {title: 'nav.main.업무현황', active: true}
          ],
          pageTitle: 'nav.main.업무현황',
          parent: 'content_mypage_workstatus'
        }
      },
      { // 마이페이지 / 알림
        path: '/content/mypage/alert',
        name: 'content-mypage-alert',
        component: () => import('@/views/content/mypage/MyPageAlert.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.마이페이지'},
            {title: 'nav.main.알림', active: true}
          ],
          pageTitle: 'nav.main.알림',
          parent: 'content_mypage_alert'
        }
      },
      { // 마이페이지 / 설정
        path: '/content/mypage/workmanager',
        name: 'content-mypage-workmanager',
        component: () => import('@/views/content/mypage/MyPageWorkManager.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.마이페이지'},
            {title: 'nav.main.설정', active: true}
          ],
          pageTitle: 'nav.main.설정',
          parent: 'content_mypage_workmanager'
        }
      },
      { // 마이페이지 / 설정 / 개인정보변경
        path: '/content/mypage/info-update',
        name: 'content-mypage-info-update',
        component: () => import('@/views/content/mypage/MyPageInfoUpdate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'breadcrumb.home.home',
              url: '/home'
            },
            {title: 'nav.main.마이페이지'},
            {title: 'nav.main.설정'},
            {title: 'nav.main.개인정보변경', active: true}
          ],
          pageTitle: 'nav.main.개인정보변경',
          parent: 'content_mypage_info-update'
        }
      },


      // board
      // pathToRegexpOptions: { strict: true }를 사용하여 URL을 엄격하게 처리
      // board관련 vue에서 라우터 push시 상대경로를 사용했기 때문에, URL의 마지막에 슬러시가 붙으면 안된다
      {
        path: '/board/:boardslug/',
        pathToRegexpOptions: {strict: true},
        redirect: '/board/:boardslug'
      },
      {
        path: '/board/:boardslug',
        name: 'board-list',
        component: () => import('@/views/board/BoardList.vue')
      },

      {
        path: '/board/:boardslug/create/',
        pathToRegexpOptions: {strict: true},
        redirect: '/board/:boardslug/create'
      },
      {
        path: '/board/:boardslug/create',
        name: 'board-create',
        component: () => import('@/views/board/BoardCreated.vue')
      },

      {
        path: '/board/:boardslug/:postId/',
        pathToRegexpOptions: {strict: true},
        redirect: '/board/:boardslug/:postId'
      },
      {
        path: '/board/:boardslug/:postId',
        name: 'board-detail',
        component: () => import('@/views/board/BoardDetail.vue')
      },

      {
        path: '/board/:boardslug/:postId/update/',
        pathToRegexpOptions: {strict: true},
        redirect: '/board/:boardslug/:postId/update'
      },
      {
        path: '/board/:boardslug/:postId/update',
        name: 'board-update',
        component: () => import('@/views/board/BoardUpdate.vue')
      },

      {
        path: '/board/:boardslug/:postId/reply/',
        pathToRegexpOptions: {strict: true},
        redirect: '/board/:boardslug/:postId/reply'
      },
      {
        path: '/board/:boardslug/:postId/reply',
        name: 'board-reply',
        component: () => import('@/views/board/BoardReply.vue')
      }

    ]
  },

  // =============================================================================
  // FULL PAGE LAYOUTS
  // =============================================================================
  {
    path: '/pages/:custom',
    component: () => import('@/views/Pages.vue'),
    children: []
  }
]
